import React, { Component } from 'react';
import { Link, Redirect } from 'react-router-dom';

import Button from '../../artzu-ui/src/Button';

import Modal from '../../artzu-ui/src/Modal';
import { ValidatorForm } from 'react-form-validator-core';
import AutzuLogoLayout from './AutzuLogoLayout';
import TextInput from './TextInput';
import { postData } from '../../utils/request';
import './login.css';

class ResetPass extends Component {
  constructor(props) {
    super(props);

    this.state = {
      password: '',
      password_confirmation: '',
      reset_password_token: this.props.location.search.split('=')[1],
      open: false,
      error: null
    };
  }

  componentWillMount() {
    // custom rule will have name 'isPasswordMatch'
    ValidatorForm.addValidationRule('isPasswordMatch', value => {
      if (value !== this.state.password) {
        return false;
      }
      return true;
    });
    ValidatorForm.addValidationRule('minLength', () => {
      if (this.state.password.length < 8) {
        return false;
      }
      return true;
    });
  }

  openModal = () => {
    this.setState({ open: true });
  };

  closeModal = () => {
    this.setState({ open: false });
  };

  handleChange = ({ target }) => {
    const { name } = target;
    const val = target.value;
    this.setState({ [name]: val });
  };

  handleSubmit = () => {
    postData('reset', { user: { ...this.state } })
      .then(() => {
        this.openModal();
      })
      .catch(() => this.setState({ error: 'Invalid email address' }));
  };

  resetPass = () => {
    const { password, password_confirmation, open } = this.state;
    return (
      <AutzuLogoLayout>
        <h3 style={{ color: 'white', fontWeight: 200 }}>Reset Password</h3>

        <ValidatorForm
          className="login__form"
          instantValidate={false}
          onSubmit={() => this.handleSubmit()}>
          <div className="login__inputs">
            <TextInput
              floatingLabelText="Enter New Password"
              onChange={this.handleChange}
              name="password"
              type="password"
              value={password}
              validators={['required', 'minLength']}
              errorMessages={[
                'this field is required',
                'password must be 8 characters or more'
              ]}
            />
            <TextInput
              style={{
                marginLeft: '0',
                paddingLeft: '3rem',
                width: '31.5rem'
              }}
              floatingLabelText="Confirm New Password"
              name="password_confirmation"
              onChange={this.handleChange}
              value={password_confirmation}
              type="password"
              validators={['isPasswordMatch', 'required']}
              errorMessages={[
                "password doesn't match",
                'this field is required'
              ]}
            />
          </div>
          <div className="login__button">
            <Button
              className="reset__button"
              size="xl"
              primary
              fullWidth
              type="submit"
              label="Reset Password"
            />
            <p className="login__signup">
              <Link to="/login">Back to Login</Link>
            </p>
          </div>
        </ValidatorForm>
        <Modal open={open}>
          <div className="reset__modal">
            <p className="reset__text">
              Your password has been reset, please try logging in again.
            </p>
            <Link to="/login">
              <Button
                size="xl"
                primary
                fullWidth
                type="submit"
                label="Back to Log In"
              />
            </Link>
          </div>
        </Modal>
      </AutzuLogoLayout>
    );
  };

  render() {
    const { loggedIn } = this.props;
    if (loggedIn) {
      return <Redirect to="/dashboard" />;
    }
    return this.resetPass();
  }
}
export default ResetPass;



// WEBPACK FOOTER //
// ./src/components/User/ResetPass.js